
export default {
    props: ['icon', 'message']
};
